<template>
    <div class="container-fluid d-flex flex-column flex-grow-1 mt-3">
        <div class="animated fadeIn">
            <b-row>
                <b-col lg="12">
                    <transition name="fade">
                        <b-card no-body>
                            <div slot="header">
                                <i class="fa fa-edit"></i> {{ pageName }}
                                <div class="card-header-actions">
                                    <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
                                        <i class="icon-arrow-up"></i>
                                    </b-link>
                                </div>
                            </div>
                            <b-collapse id="collapse1" visible>
                                <b-card-body>
                                    <b-row>
                                        <b-col sm="3">
                                            <b-form-group>
                                                <label class="required">Project Type</label>
                                                <b-form-select v-model="selectedProjectType" :options="projectTypes" @input="getProjectsDataByType"></b-form-select>
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="3">
                                            <b-form-group>
                                                <label class="required">Project</label>
                                            <LookUp v-model="selectedProject" @input="onProjectChange"
                                                    @search="searchProjects"
                                                    placeholder="Select"
                                                    :options="projectList"></LookUp>
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="3">
                                            <b-form-group>
                                                <label>Task</label>
                                            <LookUp v-model="selectedTask" @input="onChangeTask"
                                                    @search="searchTasks"
                                                    placeholder="Select"
                                                    :options="taskList"></LookUp>
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="3">
                                            <DatePicker v-model="item.date">Timesheet Date</DatePicker>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col sm="12">
                                            <table v-if="item && item.projects && item.projects.length>0 " class="table table-bordered table-sm">
                                                <tbody >
                                                <tr v-for="(project, projectIdx) in item.projects" :key="projectIdx">
                                                    <td colspan="2" style="border: 0">
                                                        <table class="table table-bordered table-sm" width="100%" >
                                                            <tr>
                                                                <td colspan="2" style="text-align: center;font-size: 14px; background-color: #ece6e3;">
                                                                    <b>Project</b> : {{project.projectNumber}} -> {{project.projectName}}
                                                                    <b>Customer</b> : {{project.customerName}}
                                                                </td>
                                                            </tr>
                                                            <tr v-for="(task, idx) in project.tasks" :key="idx">
                                                                <td colspan="2" style="border: 0">
                                                                    <table class="table table-bordered table-sm" width="100%" >
                                                                        <tr>
                                                                            <td colspan="2" style="font-size: 14px;"><b>{{task.taskName}}</b></td>
                                                                        </tr>
                                                                        <tr v-for="(assignee, idx) in task.assignees" :key="idx">
                                                                            <td width="80%">
                                                                                <label style="margin-left: 60px; font-size: 14px;"> {{assignee.employee}} </label>
                                                                            </td>
                                                                            <td width="20%">
                                                                                <input type="text" v-model="assignee.estimateTimeInString"/>
                                                                            </td>
                                                                        </tr>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            <div v-else><h4 style="text-align:center">No Data Available This Criteria </h4></div>
                                        </b-col>
                                    </b-row>
                                    <div class="d-flex justify-content-end">
                                        <div v-if="item && item.projects && item.projects.length>0" class="form-actions">
                                            <b-button  right type="submit" variant="primary" @click="onSubmit">Save
                                            </b-button>
                                        </div>
                                    </div>
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                    </transition>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import {required} from 'vuelidate/lib/validators';
    import moment from 'moment'
    export default {
        name: "TimesheetAddPage",
        data() {
            return {
                projectTypes: [{text: 'All', value: 'timesheet_app_all_project_lookup'}, {text: 'Regular', value: 'timesheet_app_regular_project_lookup'}, {text: 'Extra', value: 'timesheet_app_extra_project_lookup'}],
                projectList: [],
                taskList: [],
                selectedProjectType:'timesheet_app_regular_project_lookup',
                selectedProject: null,
                selectedTask: null,
                item: {},
                logoUrl: '',
            };
        },
        created() {
           this.getProjectsDataByType()
        },

        computed: {
            pageName() {
                return this.$route.params.id ? 'Edit Timesheet' : 'Add Timesheet'
            }
        },
        methods: {
            searchProjectsInCreate(search) {
                this.axios.get('dynamic/look-up', {params: {queryName: this.selectedProjectType, searchKey: search}})
                    .then(({data}) => {
                        this.setOptions(data.data,'PROJECT')
                    }).catch(() => {
                    this.$toastr.error('Internal server error')
                })
            },
            searchProjects (search, loading) {
                loading(true)
                this.axios.get('dynamic/look-up', {params: {queryName: this.selectedProjectType, searchKey: search}})
                    .then(({data}) => {
                        loading(false)
                        this.setOptions(data.data,'PROJECT')
                    }).catch(() => {
                    loading(false)
                    this.$toastr.error('Internal server error')
                })
            },
            searchTasks (search, loading) {
                loading(true)
                this.axios.get('task/look-up', {params: {projectId: this.selectedProject.value, searchKey: search}})
                    .then(({data}) => {
                        loading(false)
                        this.setOptions(data.data,'TASK')
                    }).catch(() => {
                    loading(false)
                    this.$toastr.error('Internal server error')
                })
            },
            selectTasksInCreate (search) {
                if(!this.selectedProject || !this.selectedProject.value){
                    return
                }
                this.axios.get('task/look-up', {params: {projectId: this.selectedProject.value, searchKey: search}})
                    .then(({data}) => {
                        this.setOptions(data.data,'TASK')
                    }).catch(() => {
                    this.$toastr.error('Internal server error')
                })
            },
            setOptions (data, lookUpType) {
                const numbItems = []
                data.list.forEach(function (item) {
                    numbItems.push({
                        label: item.name,
                        value: item.id
                    })
                })
                if (lookUpType ==='PROJECT') {
                    this.projectList = numbItems
                } else {
                    this.taskList = numbItems
                }
            },
            onProjectChange () {
                this.taskList = [],
                this.selectedTask = {},
                this.selectTasksInCreate()
                this.getProjectEmployees()
            },
            onChangeTask () {
                this.getProjectEmployees()
            },
            getProjectEmployees () {
                if (!this.selectedProject || !this.selectedProject.value) {
                    this.getAllProjectTasksAndEmployee()
                    return
                }
                this.item = {}
                this.$loading.show();
                this.axios.get('project/projectTasksEmployeeList', {params: {
                        projectid: this.selectedProject.value,
                        taskid: (this.selectedTask ? this.selectedTask.value : null)}})
                    .then(({data}) => {
                        this.$loading.hide();
                        this.item = data.data
                    }).catch(() => {
                    this.$loading.hide();
                    this.$toastr.error('Internal server error')
                })
            },
            getAllProjectTasksAndEmployee() {
                this.item = {}
                this.$loading.show();
                this.axios.get('project/projectAndTasksEmployesForTimesheetApp', {params: {
                        queryName: this.selectedProjectType}})
                    .then(({data}) => {
                        this.$loading.hide();
                        this.item = data.data
                    }).catch(() => {
                    this.$loading.hide();
                    this.$toastr.error('Internal server error')
                })
            },
            getProjectsDataByType(){
                this.searchProjectsInCreate()
                this.getAllProjectTasksAndEmployee()
            },
            onSubmit() {
                if (this.$v.item.$invalid) {
                    this.$v.$touch()
                    this.$toastr.error('Please Select Timesheet Date')
                    return
                }
                let axios
                this.item.date = moment(this.item.date).format('YYYY-MM-DD 00:00:00')
                if (this.item.id) {
                    axios = this.axios.put('project/insert-timesheet-entries', this.item)
                } else {
                    axios = this.axios.post('project/insert-timesheet-entries', this.item)
                }

                axios.then((res) => {
                    if (res.data) {
                        this.$toastr.info('Timesheet entries saved successfully')
                    } else {
                        this.$toastr.error(res.data.message)
                    }
                })
            }
        },
        validations: {
            item: {
              date: {
                    required
                }
            }
        }
    }
</script>

<style scoped>

</style>
